import { render, staticRenderFns } from "./formularioEnvioPedido.vue?vue&type=template&id=5dce1f9b&scoped=true&"
import script from "./formularioEnvioPedido.vue?vue&type=script&lang=js&"
export * from "./formularioEnvioPedido.vue?vue&type=script&lang=js&"
import style0 from "./formularioEnvioPedido.vue?vue&type=style&index=0&id=5dce1f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce1f9b",
  null
  
)

export default component.exports